export default __webpack_public_path__ + "eafb17ca10b93dd7f1d86ce962ca3bb5.png";